import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useAuthModalStore } from '../store/auth-modal';

export const AuthGuard = WrappedComponent => {
  return function ProtectedComponent(props) {
    const { isUserLogged } = useAuthModalStore();
    const router = useRouter();
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
      setIsMounted(true);
    }, []);

    useEffect(() => {
      if (isMounted && !isUserLogged) {
        router.push({ pathname: '/login', query: { from: router.pathname } });
      }
    }, [isMounted, isUserLogged, router]);

    if (!isMounted || !isUserLogged) {
      return null;
    }
    return <WrappedComponent {...props} />;
  };
};
